import DrawerNotificationButtonGroups from '@/components/Drawer/DrawerNotificationButtonGroups'

interface Props {
  testIdPrimary: string
  testIdSecondary?: string
  testIdTertiary?: string
  primaryButtonLabel: string
  secondaryButtonLabel?: string
  tertiaryButtonLabel?: string
  onClickPrimary: () => void
  onClickSecondary?: () => void
  onClickTertiary?: () => void
  isPrimaryDisabled?: boolean
  isSecondaryDisabled?: boolean
  isTertiaryDisabled?: boolean
}

export default function EmailTemplateButtonGroup({
  testIdSecondary,
  testIdTertiary,
  testIdPrimary,
  onClickPrimary,
  onClickSecondary,
  onClickTertiary,
  primaryButtonLabel,
  secondaryButtonLabel,
  tertiaryButtonLabel,
  isPrimaryDisabled,
  isSecondaryDisabled,
}: Props) {
  return (
    <>
      <DrawerNotificationButtonGroups
        hasSecondaryButton={Boolean(secondaryButtonLabel)}
        hasTertiaryButton={true}
        testIdPrimary={testIdPrimary}
        testIdSecondary={testIdSecondary}
        testIdTertiary={testIdTertiary}
        primaryButtonLabel={primaryButtonLabel}
        secondaryButtonLabel={secondaryButtonLabel}
        tertiaryButtonLabel={tertiaryButtonLabel}
        onClickPrimary={onClickPrimary}
        onClickSecondary={onClickSecondary}
        onClickTertiary={onClickTertiary}
        isPrimaryDisabled={isPrimaryDisabled}
        isSecondaryDisabled={isSecondaryDisabled}
      />
    </>
  )
}
